export const isImageFile = (fileName: string) => {
  const [ext] = fileName.split(".").reverse();
  return ["png", "jpg", "jpeg", "gif", "webp"].includes(ext);
};
